import React, { Component } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import Chart from 'chart.js/auto'; // Import Chart.js library
import PageTitle from "../../Components/PageTitle";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import withRouter from "../../Utils/withRouter";
import { decodeData } from '../../Constants/constants';
class AttendenceDashboard extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            events: [],
            rows: [],
            next: false,
            prev: false,
            loadingList: false,
            postLoading: false,
            decodedData: [],
        };
        this.chartRef = React.createRef();
        this.chartInstance = null; // Hold the Chart.js instance
    }

    componentDidMount() {
        // Initialize Chart.js Polar Chart
        this.chartInstance = new Chart(this.chartRef.current, {
            type: 'polarArea',
            data: {
                labels: ['Absent', 'Present', 'Issue'],
                datasets: [{
                    label: 'Attendence  Status',
                    data: [11, 12, 13],
                    backgroundColor: [
                        'rgb(247,102,110)',
                        'rgb(60,209,136)',
                        'rgb(104,124,254)',
                    ]
                }]
            },
            options: {}
        });
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();

        });
    }
    componentDidUpdate(prevProps, prevState) {
            if (prevState.permissions !== this.context.permissions) {
              // console.log("Permissions Updated:", this.context.permissions);
                const { permissions } = this.context;
                if (permissions.length > 0) {
                  const queryParams = new URLSearchParams(window.location.search);
                  const encodedData = queryParams.get("abs");
                  const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                  if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                    this.setState({ decodedData });
                  }
                } else {
                  console.warn("Permissions not yet available. Retrying...");
                }
            }
          }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        const employee_id = this.props.params.employee_id;

        axios.get(`${apiURL}Attendance/GetEmployeeByAttendance`, {
            params: { employee_id: employee_id, }, headers,
        })
            .then((response) => {

                var data = response.data;
                // console.log("INtime", data.data[0].punch_in_datetime);
                if (response.data.success === true) {
                    var events = [];
                    for (var i = 0; i < data.data.length; i++) {
                        events.push({ title: 'Present', start: data.data[0].punch_in_datetime });
                    }

                    this.setState({
                        rows: data.data,
                        next: data.next,
                        prev: data.prev,
                        page: data.page,
                        total_records: data.total_records,
                        total_pages: data.total_pages,
                        events: events,
                        loadingList: false,
                    });
                } else {
                    this.setState({ loadingList: false });
                }
            });
    };



    componentWillUnmount() {
        // Destroy the chart instance on component unmount
        if (this.chartInstance) {
            this.chartInstance.destroy();
        }
    }

    handleCreateEvent = () => {
        this.setState({ showModal: true });
    };

    render() {
        function renderEventContent(eventInfo) {
            return (
                <>
                    <b>{eventInfo.timeText}</b>
                    <i>{eventInfo.event.title}</i>
                </>
            );
        }

        function getTime(dateTimeString) {
            const date = new Date(dateTimeString);
            const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', });
            return time;
        }
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <PageTitle title={`Attendance Dashboard `} primary={`Home`} />
                        <div className="row">
                            <div className="col-3">
                                <div className="card">
                                    <div className="card-header">
                                        <canvas ref={this.chartRef}></canvas>
                                    </div>
                                </div>
                                <div className="pe-2 me-n1 mb-3 simplebar-scrollable-y" data-simplebar="init" style={{ height: 400 }}>
                                    <div className="simplebar-wrapper" style={{ margin: '0px -8px 0px 0px' }}>
                                        <div className="simplebar-height-auto-observer-wrapper">
                                            <div className="simplebar-height-auto-observer" />
                                        </div>
                                        <div className="simplebar-mask">
                                            <div className="simplebar-offset" style={{ right: 0, bottom: 0 }}>
                                                <div className="simplebar-content-wrapper" tabIndex={0} role="region" aria-label="scrollable content" style={{ height: '100%', overflow: 'hidden scroll' }}>
                                                    <div className="simplebar-content" style={{ padding: '0px 8px 0px 0px' }}>
                                                        <div className="upcoming-event-list">
                                                            {this.state.rows.length === 0 ? (
                                                                <div className="card mb-3">
                                                                    <div className="card-body">
                                                                        <div className="d-flex mb-3">
                                                                            <div className="flex-grow-1">
                                                                                <i className="mdi mdi-checkbox-blank-circle me-2 text-info"></i>
                                                                                <span className="fw-medium">
                                                                                    No Attendence found!
                                                                                </span>
                                                                            </div>
                                                                            <div className="flex-shrink-0">
                                                                                <small className="badge bg-primary-subtle text-primary ms-auto">
                                                                                    No Attendence found !!
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                this.state.rows.map((row) => (
                                                                    <div className="card mb-3" key={row.employee_attendance_id}>
                                                                        <div className="card-body">
                                                                            <div className="d-flex mb-3">
                                                                                <div className="flex-grow-1">
                                                                                    <i className="mdi mdi-checkbox-blank-circle me-2 text-info"></i>
                                                                                    <span className="fw-medium">{getTime(row.punch_in_datetime) || "--"}</span>
                                                                                </div>
                                                                                <div className="flex-shrink-0">
                                                                                    <small className="badge bg-primary-subtle text-primary ms-auto">
                                                                                        {getTime(row.punch_in_datetime) || "--"} To {getTime(row.punch_out_datetime) || "--"}
                                                                                    </small>
                                                                                </div>
                                                                            </div>
                                                                            <h6 className="card-title fs-16">Attendance</h6>
                                                                            <p className="text-muted text-truncate-two-lines mb-0"></p>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            )}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="simplebar-placeholder" style={{ width: 354, height: 2397 }} /></div>
                                    <div className="simplebar-track simplebar-horizontal" style={{ visibility: 'hidden' }}>
                                        <div className="simplebar-scrollbar" style={{ width: 0, display: 'none' }} />
                                    </div>
                                    <div className="simplebar-track simplebar-vertical" style={{ visibility: 'visible' }}>
                                        <div className="simplebar-scrollbar" style={{ height: 66, display: 'block', transform: 'translate3d(0px, 2px, 0px)' }} />
                                    </div>
                                </div>

                                <div className="card">
                                    <div className="card-body bg-info-subtle">
                                        <div className="d-flex">
                                            <div className="flex-shrink-0">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-calendar text-info icon-dual-info">
                                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                                    <line x1="16" y1="2" x2="16" y2="6"></line>
                                                    <line x1="8" y1="2" x2="8" y2="6"></line>
                                                    <line x1="3" y1="10" x2="21" y2="10"></line>
                                                </svg>
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h6 className="fs-15">Welcome to your Calendar!</h6>
                                                <p className="text-muted mb-0">Event that applications book will appear here. Click on an event to see the details and manage applicants event.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-9">
                                <div className="card">
                                    <div className="card-header">
                                        <FullCalendar
                                            plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
                                            initialView='dayGridMonth'
                                            views={{
                                                dayGridMonth: { buttonText: 'Month' },
                                                timeGridWeek: { buttonText: 'Week' },
                                                timeGridDay: { buttonText: 'Day' },
                                                list: { buttonText: 'List' }
                                            }}
                                            headerToolbar={{
                                                left: 'prev,next today',
                                                center: 'title',
                                                right: 'dayGridMonth,timeGridWeek,timeGridDay,list'
                                            }}
                                            weekends={true}
                                            events={this.state.events}
                                            eventContent={renderEventContent}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(AttendenceDashboard);







